import { type Translation } from "./en";

export const ptBr: Translation = {
  ai_speech_preview_free_title: "Voz Padrão",
  ai_speech_preview_free_desc: "Voz robótica gratuita",
  ai_speech_preview_pro_desc: "Voz de alta qualidade com entonação natural",
  ai_speech_preview_free_lbl: "Grátis",
  ai_speech_lang_support: "Suporta mais de 30 idiomas",
  ai_speech_listen: "Ouvir amostra",
  voice_type_none: "Nenhum",
  review_custom: "Selecionar o que revisar",
  custom_new_cards: "Novas cartas",
  custom_due_cards: "Cartas para revisar",
  review_card_type: "Tipo de carta",
  settings_lang: "Idioma",
  copied: "Copiado",
  copy_code: "Copiar código",
  html_column: "Coluna",
  html_row: "Linha",
  logout: "Sair",
  browser_no_personal_decks_start: "Você ainda não tem baralhos pessoais",
  browser_no_personal_decks_end: ". Boa sorte! 😊",
  browser_no_personal_decks_link: "Aprenda como usar o MemoCard em ",
  error_contact_support:
    "Ocorreu um erro. Por favor, entre em contato com o suporte para que possamos ajudar.",
  ai_card_input_mode_supports: "Suporta diferentes idiomas",
  upgrade_pro: "Obter Pro",
  login_google: "Entrar com Google",
  youtube_channel: "Canal do YouTube",
  card_input_mode_changed: "Modo de entrada de cartão alterado",
  card_input_mode_type: "Se você digitar",
  card_input_mode_manual: "Entrada manual",
  card_input_mode_get: "você obterá o cartão",
  generate: "Gerar",
  card_input_mode_screen: "Modo de entrada de cartão",
  yes: "Sim",
  ai_speech_generate: "Gerar",
  ai_speech_title: "Voz de IA",
  ai_speech_empty: "Nenhuma voz de IA gerada. Escolha o lado do cartão abaixo.",
  ai_speech_type: "Ou digite o texto necessário",
  ai_speech_validate: "Por favor, selecione um lado ou digite o texto",
  confirm_ok: "Confirmar",
  confirm_cancel: "Cancelar",
  payment_success:
    "Pagamento realizado com sucesso. Aproveite os recursos adicionais 😊",
  payment_failed:
    "Pagamento falhou. Estamos cientes do problema e trabalhando nele. Por favor, entre em contato com o suporte através de Configurações > Suporte",
  cards_add: "Adicionar cartão",
  error: "Erro",
  user_settings_updated: "Configurações atualizadas",
  error_solving: "Estamos resolvendo o problema",
  is_on: "Ligado",
  is_off: "Desligado",
  folder_form_no_decks: "Não há baralhos na pasta",
  card_next: "Próxima",
  card_previous: "Anterior",
  ui_loading: "Carregando...",
  yes_no: "Lembrar",
  card_answer_type: "Tipo de cartão",
  answer_type_explanation_choice: `Um cartão com opções de resposta`,
  answer_type_explanation_remember: `Um cartão com botões "Lembrar" e "Não lembrar"`,
  answer_type_choice: "Escolha",
  profile_section: "Perfil",
  folder_form_quit_card_confirm: "Sair sem salvar a pasta?",
  read_more: "Leia mais",
  review_idk: "Não sei",
  review_again: "De novo",
  review_hard: "Difícil",
  review_good: "Bom",
  review_easy: "Fácil",
  user_stats_empty_text: "Estude mais cartões para ver os dados",
  hide_card_forever: "Ocultar para sempre",
  mute_cards: "Silenciar som",
  unmute_cards: "Ativar som",
  hide_card_forever_confirm_title:
    "Tem certeza de que deseja ocultar este cartão para sempre? Você nunca mais o verá",
  next: "Próximo",
  payment_tos_and_pp_agree: "Ao comprar o MemoCard, você concorda com os ",
  payment_description: "Desbloqueie mais recursos",
  payment_paid_until: "Pago até",
  payment_pp: "Política de Privacidade",
  privacy_policy: "Política de Privacidade",
  payment_tos: "Termos de Serviço",
  payment_and: " e ",
  ai_cards_left: "Cartões de IA restantes este mês",
  payment_included: "O que está incluído",
  payment_choose_duration: "Escolha a duração",
  payment_method_stars: "Estrelas do Telegram",
  payment_choose_subscription: "Assinatura",
  payment_choose_method: "Método de pagamento",
  payment_method_usd: "Cartão de crédito",
  wysiwyg_bold: "Negrito",
  wysiwyg_clear_formatting: "Limpar formatação",
  wysiwyg_text_color: "Cor do texto",
  repeat_cards_anyway: `Repetir mesmo assim`,
  wysiwyg_italic: "Itálico",
  wysiwyg_big_header: "Cabeçalho grande",
  wysiwyg_undo: "Desfazer",
  formatting: "Formatação",
  validation_answer_at_least_one_correct:
    "Selecione pelo menos uma resposta correta",
  duplicate_folder_confirm: "Tem certeza de que deseja duplicar esta pasta?",
  add_answer: "Adicionar resposta",
  answer_text: "Texto da resposta",
  advanced: "Avançado",
  review_correct_label: "Correto",
  review_wrong_label: "Incorreto",
  validation_at_least_one_answer_required:
    "Pelo menos uma resposta deve ser fornecida",
  validation_at_least_one_deck: "Por favor, selecione pelo menos 1 baralho",
  card_preview: "Visualização",
  review_folder: "Revisar pasta",
  add_deck_short: "Baralho",
  deck: "Baralho",
  deck_description: "Uma coleção de cartões",
  folder: "Pasta",
  folder_description: "Uma coleção de baralhos",
  no_decks_to_add: "Não há mais baralhos para adicionar",
  add_deck_to_folder: "Adicionar baralho à pasta",
  decks_in_other_folders: "Baralhos em outras pastas",
  add_folder: "Adicionar pasta",
  edit_folder: "Editar pasta",
  decks: "Baralhos",
  my_decks: "Meus baralhos",
  show_all_decks: "Mostrar todos",
  hide_all_decks: "Ocultar",
  select_all: "Selecionar tudo",
  deselect_all: "Desselecionar tudo",
  select: "Selecionar",
  selected: "Selecionado",
  deck_form_remove_card_confirm:
    "Tem certeza de que deseja remover o cartão? Todas as revisões de cartões de todos os usuários serão perdidas",
  deck_form_remove_cards_confirm:
    "Tem certeza de que deseja remover todos os cartões selecionados?",
  add_deck: "Adicionar baralho",
  add: "Adicionar",
  edit_deck: "Editar baralho",
  edit_card: "Editar cartão",
  edit: "Editar",
  view: "Visualizar",
  all_decks_reviewed: `Ótimo trabalho! 🌟 Você já revisou todos os baralhos por enquanto. Volte posteriormente para mais.`,
  public_decks: "Baralhos públicos",
  explore_public_decks: "Explorar mais baralhos",
  news_and_updates: "Notícias e atualizações",
  telegram_channel: "Canal do Telegram",
  settings: "Configurações",
  deck_has_been_added: "Este baralho está na sua lista",
  deck_catalog: "Catálogo de Baralhos",
  translated_to: "Traduzido para",
  any_language: "Qualquer idioma",
  category: "Categoria",
  any_category: "Qualquer",
  deck_search_not_found: "Nenhum baralho encontrado",
  card_search_not_found: "Nenhum cartão encontrado",
  deck_search_not_found_description:
    "Tente atualizar os filtros para ver mais baralhos",
  category_English: "Inglês",
  category_Other: "Outro",
  category_Thai: "Tailandês",
  category_Geography: "Geografia",
  category_History: "História",
  category_Chemistry: "Química",
  category_Spanish: "Espanhol",
  save: "Salvar",
  add_card: "Adicionar cartão",
  add_card_short: "Cartão",
  card_front_title: "Lado da frente",
  card_back_title: "Lado de trás",
  card_front_side_hint: "A pergunta ou indicação",
  card_back_side_hint: "A resposta que você precisa fornecer",
  card_field_example_title: "Explanação",
  card_field_example_hint: "Informação adicional opcional",
  cards: "Cartões",
  search_card: "Buscar cartão",
  card_sort_by_date: "Data",
  card_sort_by_front: "Frente",
  card_sort_by_back: "Verso",
  sort_by: "Ordenar por",
  title: "Título",
  description: "Descrição",
  speaking_cards: "Cartões com voz",
  voice_language: "Idioma da voz",
  card_speak_side: "Lado do cartão",
  front: "Frente",
  back: "Verso",
  card_speak_description:
    "Reproduzir áudio falado para cada flashcard para ouvir a pronúncia.",
  review_deck_finished: `Parabéns! Você terminou este baralho por enquanto. 🎉`,
  review_all_cards: `Você revisou todos os cartões para hoje 🎉`,
  review_finished_want_more: "Quer mais? Você tem",
  review_finished_to_review: "para estudar",
  review_deck: "Revisar baralho",
  cards_to_repeat: "Para repetir",
  cards_new: "Novos cartões",
  cards_total: "Total de cartões",
  duplicate: "Duplicar",
  duplicate_deck_confirm: "Tem certeza de que deseja duplicar este baralho?",
  delete_deck_confirm_shared: "Excluir baralho da sua coleção?",
  delete_folder_confirm_author:
    "Excluir pasta do MemoCard? Esta ação não pode ser desfeita",
  delete_folder_confirm_shared: "Excluir pasta da sua coleção?",
  delete_deck_confirm_author:
    "Excluir baralho do MemoCard? Esta ação não pode ser desfeita",
  delete: "Deletar",
  no_cards_to_review_in_deck: `Ótimo trabalho! 🌟 Você já revisou todos os cartões neste baralho por enquanto. Volte posteriormente para mais.`,
  no_cards_to_review_all: `Ótimo trabalho! 🌟 Você revisou todos os cartões para hoje. Volte posteriormente para mais.`,
  review_show_answer: "Mostrar resposta",
  share: "Compartilhar",
  warning_telegram_outdated_title: "Seu Telegram está desatualizado",
  warning_telegram_outdated_description:
    "Por favor, atualize seu Telegram para garantir o funcionamento estável deste aplicativo.",
  settings_review_notifications: "Notificações de revisão",
  settings_time: "Hora",
  settings_review_notifications_hint:
    "Lembretes diários ajudam você a lembrar de repetir os cartões",
  validation_deck_title: "O título do baralho é obrigatório",
  deck_form_quit_card_confirm: "Sair sem salvar o cartão?",
  deck_form_quit_deck_confirm: "Sair sem salvar o baralho?",
  deck_category: "Categoria do baralho",
  validation_required: "Este campo é obrigatório",
  settings_contact_support: "Contatar suporte no Telegram",
  settings_support_hint: "Se você tiver algum problema, dúvida ou sugestão",
  share_link_copied: "O link foi copiado para a área de transferência",
  go_back: "Voltar",
  user_stats_btn: "Estatísticas",
  user_stats_page: "Minha Estatística",
  user_stats_remembered: "Cartões Memorizados",
  user_stats_remembered_hint: "Clicado 'Acertei' 5 vezes seguidas",
  user_stats_learning: "Em Processo de Aprendizagem",
  user_stats_learning_hint: "Clicado 'Acertei' menos de 5 vezes seguidas",
  user_stats_total: "Total de Cartões",
  user_stats_total_hint: "Cartões abertos pelo menos uma vez",
  user_stats_learning_time: "Distribuição do Tempo de Aprendizagem",
  user_stats_learning_time_hint:
    "Como o seu tempo é distribuído entre o estudo de material novo e a revisão",
  user_stats_chart_min_expl: "Não conheço o cartão",
  user_stats_chart_max_expl: "Conheço o cartão muito bem",
  freeze_title: "Congelar cartões",
  freeze_rule_4:
    "Se você adicionar um cartão durante o período de congelamento, ele não será afetado pelo congelamento.",
  freeze_rule_3: "O congelamento de cartões é irreversível.",
  freeze_notified: "Você receberá uma notificação",
  freeze_rule_2:
    "A quantidade de cartões para revisar não aumentará durante o congelamento; você verá o mesmo número de cartões quando o congelamento terminar.",
  freeze_rule_1:
    "Todos os seus cartões serão pausados e você não receberá notificações.",
  how: "Como funciona",
  freeze_for: "Congelar por",
  freeze_for_or_manual: "ou digite manualmente",
  freeze_confirm_freeze:
    "Tem certeza de que deseja congelar seus cartões? Esta ação não pode ser desfeita.",
  validate_positive: "Por favor, insira um número positivo",
  validate_under_100: "Por favor, insira um número menor que 100",
  freeze_hint: "Adie o estudo dos cartões",
  ai_cards_added: "Cartões adicionados",
  quit_without_saving: "Sair sem salvar?",

  ai_cards_generate: "Gerar cartões",
  ai_cards_no_previous_prompts: "Nenhuma solicitação anterior",
  ai_cards_by_ai: "Cartões gerados",
  ai_cards_confirm_delete: "Excluir este cartão?",
  ai_cards_title: "Criação de cartões com IA",
  ai_cards_prompt: "Descrição do baralho",
  ai_cards_previous_prompts: "Histórico de solicitações",
  ai_cards_use_template: "Usar modelo",
  ai_cards_prompt_back: "Verso do cartão",
  ai_cards_prompt_front: "Frente do cartão",

  // Global Search
  global_search_placeholder: "Buscar baralhos, pastas, cartões",
  global_search_no_results: "Nenhum resultado encontrado",
  global_search_cancel: "Cancelar",
  global_search_start_typing:
    "Comece a digitar para buscar baralhos, pastas e cartões",
  global_search_tabs_cards: "Cartões",
  global_search_tabs_decks: "Baralhos",
  global_search_tabs_folders: "Pastas",
  global_search_context_folder: "Pasta",
  global_search_context_deck: "Baralho",

  // About page
  about_title: "Sobre",
  about_paragraph_1:
    "MemoCard existe porque apps como Anki são chatos de usar. São poderosos, mas você perde horas configurando, não avisam quando revisar e parecem coisa antiga.",
  about_paragraph_2:
    "No concurso de Mini Apps do Telegram, fiz o app de cartões que sempre quis. Não precisa configurar nada, os lembretes já funcionam e tudo é simples.",
  about_paragraph_3:
    "Usa o método científico de repetição espaçada do Ebbinghaus. Os cartões aparecem na hora certa - quando você está quase esquecendo. É assim que se memoriza melhor.",
  about_paragraph_4:
    "MemoCard ganhou prêmio no concurso. Hoje milhares de pessoas usam no mundo todo.",
  about_visit_website: "Visitar site →",
  about_github_frontend: "Repositório do GitHub do frontend →",

  // Card Input Mode Form
  card_input_mode_form_title: "Título",
  card_input_mode_form_ai_prompt: "Prompt de IA",
  card_input_mode_form_create_title: "Criar modo de entrada",
  card_input_mode_form_edit_title: "Editar modo de entrada",
  card_input_mode_form_delete_confirm: "Excluir este modo de entrada?",
  card_input_mode_add_button: "Adicionar modo de entrada",
  card_input_mode_form_title_placeholder: "ex. Definições em Inglês",
  card_input_mode_form_prompt_placeholder:
    "ex. Gere um cartão de definição para a palavra :template_word",
  card_input_mode_form_front_placeholder: "ex. Palavra ou termo",
  card_input_mode_form_back_placeholder: "ex. Definição simples",
  card_input_mode_form_example_placeholder: "ex. Exemplo de uso ou contexto",
  card_input_mode_form_save_success: "Modo de entrada salvo",
  card_input_mode_form_delete_success: "Modo de entrada excluído",
  quit_card: "Sair do cartão",

  // Wysiwyg Help
  wysiwyg_help_title: "Guia de formatação de texto",
  wysiwyg_help_step1: "Destaque o texto que você quer alterar",
  wysiwyg_help_step2: "Pressione qualquer botão da barra de ferramentas",
  wysiwyg_help_bold: "Texto em negrito",
  wysiwyg_help_italic: "Texto em itálico",
  wysiwyg_help_color: "Alterar cor do texto",
  wysiwyg_help_heading: "Tornar o texto maior (cabeçalho)",
  wysiwyg_help_table: "Inserir uma tabela",
  wysiwyg_help_clear: "Remover toda a formatação",
  wysiwyg_help_undo: "Desfazer última ação",

  reverse_cards: "Cartões reversos",
  reverse_cards_title: "Cartões Reversos",
  reverse_cards_helper: "Crie um e ganhe dois. Ajuda a lembrar melhor",
  two_cards_created: "2 cartões foram criados",
  card_created: "Cartão criado",

  // Move card to deck
  move_card_to_deck_title: "Mover para baralho",
  move_card_without_folder: "Sem pasta",
  move_card_move: "Mover",
  move_card_open_deck: "Abrir baralho",

  // Image related
  image: "Imagem",

  // Skip card
  skip_card_for_now: "Pular por agora",
  skip_card_confirm: "Pular este cartão? Ele ficará oculto até a próxima revisão",
  review_skipped: "Pulado",
};
